import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { PluggableList } from 'react-markdown/lib/react-markdown';
import ReactMarkdown from 'react-markdown';
import { useIntl } from 'react-intl';
import rehypeSlug from 'rehype-slug';
import markdown from '../data/staticPages/privacy.md';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import LinkAndAnchor from '../components/LinkAndAnchor';
import Head from '../components/Head';
import HomeLink from '../components/HomeLink';

const PrivacyPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="privacy"
      passHref
    >
      {intl.formatMessage(messages.privacy)}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages.privacy)}
        description={intl.formatMessage(messages.privacy)}
      />
      <StaticPageComponent
        content={(
          <ReactMarkdown
            rehypePlugins={
              [rehypeSlug] as PluggableList
            }
          >
            {markdown}
          </ReactMarkdown>
        )}
        title={intl.formatMessage(messages.privacy)}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};
PrivacyPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default PrivacyPage;
